import React from "react";
import { useEffect, useImperativeHandle } from 'react';
import { useSelector } from "react-redux";
import { isEmpty, DicVal, CellType, FormatDate} from '../modules/appLibrary';


export default function Headline(props) {
    const [value, setValue] = React.useState([]);
    const storeentrydata = useSelector(state => state.form.entrydata);
    const CELLTYPE = CellType();

    useEffect(() => {
        setheadline(props.entrydata, "props.entrydata");
    }, [props.entrydata]);

    useEffect(() => {
        setheadline(storeentrydata, "storeentrydata");
    }, [storeentrydata]);

    function setheadline(entrydata, source = "") {
        if (isEmpty(props.columninfo)) return;
        if (isEmpty(entrydata)) return;
        var coldef = props.columninfo.filter(e => e.logpid === "0" && (e.primary || e.required || e.headerfix ===1));
        if (coldef.length === 0) setValue([]);
        var datas = [];
        for (let i = 0; i < coldef.length; i++) {
            if (coldef[i].headerfix === 2) continue;
            if (!isEmpty(props.hidden)) {   //表示チェック
                if (props.hidden({ id: coldef[i].logpid, type: coldef[i].type })) continue;
            }
            let data = {};
            data.id = coldef[i].columnid;
            data.name = coldef[i].columnnm.replace('★', '').replace('♯', '');
            if (coldef[i].datatype === CELLTYPE.DATE)
                data.value = FormatDate(DicVal(entrydata, data.id, ''));
            else
                data.value = DicVal(entrydata, data.id, '');

            if (coldef[i].datatype === CELLTYPE.MASTER && !isEmpty(data.value)) {
                if (DicVal(entrydata, data.id + "_nm", '') !== '')
                    data.value += ":" + DicVal(entrydata, data.id + "_nm", '');
                else
                    data.value = "";
            }
            data.primary = coldef[i].primary;
            datas.push(data);
        }
        setValue(datas);
    }

    return (
        <div style={{ position: 'absolute', top: 35, left: 220, fontSize: 10.5, whiteSpace: "nowrap"}}>
            {value.map((p) => (
                p.primary ?
                    <span style={{ minWidth: 120, display: "inline-block", marginRight: 10, fontWeight: 600 }}>{p.name}〔{p.value}〕</span>
                    :
                    <span style={{ minWidth: 120, display: "inline-block", marginRight: 10 }}>{p.name}〔{p.value}〕</span>
            ))}
        </div>
    );
}
